import React, { useEffect, useState } from "react";
import { FormControl, InputLabel, Select, MenuItem, CircularProgress } from "@mui/material";
import { getInventoryCategories } from "../../../api/inventoryService";

const CategorySelect = ({ categoryId = "", value, onChange, label = "Select Category", ...props }) => {

    const [categories, setCategories] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchData = async () => {
        try {
            const response = await getInventoryCategories();
            setCategories(response);
            } catch (error) {
                console.error("Error fetching categories:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [categoryId]);

  return (
    <FormControl fullWidth {...props}>
      <InputLabel>{label}</InputLabel>
      {loading ? (
        <CircularProgress size={24} />
      ) : (
        <Select value={value} onChange={onChange} label={label}>
          {categories.data.map((category) => (
            <MenuItem key={category.id} value={category.id}>
              {category.name}
            </MenuItem>
          ))}
        </Select>
      )}
    </FormControl>
  );
};

export default CategorySelect;